/**
 * Created by macbookaxel on 26/06/2017.
 */
export enum RACE_TYPE_ENUM {
  race = "race",
  raceOff = "raceOff",
}
